<template>
  <div class="page login-page">
    <div class="loading" v-if="loading"></div>
    <div class="weui-form" v-if="!loading&&!hasAuthInfo">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title" v-if="fromPartnerChannel">{{partner.name}}</h2>
        <h2 class="weui-form__title">
          <span v-if="fromPartnerChannel">诚邀您使用</span><span v-else>注册</span>云系统
        </h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="selector">
            <span :class="{'span-selected': area}">
              <input type="radio" name="area" id="中国大陆" v-model="area" :value="true">
              <label for="中国大陆"> {{'中国大陆'}}</label>
            </span>
            <span :class="{'span-selected': !area}">
              <input type="radio" name="area" id="其他地区" v-model="area" :value="false">
              <label for="其他地区"> {{'其他地区'}}</label>
            </span>
          </div>
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.userName"
                  class="weui-input"
                  placeholder="请输入您的真实姓名"
                />
              </div>
            </div>
            <div class="weui-cell weui-cell_active" :class="area ? '' : 'weui-cell_select weui-cell_select-before'">
              <div class="weui-cell__hd" v-if="!area" @click="selectAreaCode"><div class="weui-select">{{ '+' + signInfo.countryCode }}</div></div>
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.mobile"
                  class="weui-input"
                  placeholder="请输入您的手机号码"
                />
              </div>
            </div>
            <div class="weui-cell weui-cell_active weui-cell_vcode">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.validCode"
                  class="weui-input"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="weui-cell__ft" @click="getValidCode">
                <button
                  class="weui-btn weui-btn_default weui-vcode-btn"
                  :class="{ 'weui-btn_disabled': isLocked }"
                >
                  <span v-if="!waitTime">获取验证码</span
                  ><span v-else>{{ waitTime }}秒后再试</span>
                </button>
              </div>
            </div>
            <qcc-search-box v-if="area && isMobileChecked" placeholder="请输入企业名称" v-model="signInfo.companyName" 
              @select="onCompanySelect($event)"></qcc-search-box>
            <div class="weui-cell weui-cell_active" v-if="area && signInfo.businessCode">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.businessCode"
                  class="weui-input"
                  readonly
                />
              </div>
            </div>
            <div class="weui-cell weui-cell_active" v-if="!area">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.companyName"
                  class="weui-input"
                  placeholder="请输入企业名称"
                />
              </div>
            </div>
            <div class="weui-cell weui-cell_active" v-if="!area">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.businessCode"
                  class="weui-input"
                  placeholder="营业执照号/登记证号"
                />
              </div>
            </div>
            <div
              v-if="signInfo.inviteCode"
              class="weui-cell weui-cell_active weui-cell_disabled"
            >
              <div class="weui-cell__hd">
                <label class="weui-label">专属顾问</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" v-model="adviser.name" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells__title">选择解决方案</div>
          <div class="weui-cells weui-cells_radio">
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x11"
            >
              <div class="weui-cell__bd">
                <p>贸易云</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  class="weui-check"
                  v-model="signInfo.appId"
                  value="trade-app"
                  checked="checked"
                  id="x11"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x12"
            >
              <div class="weui-cell__bd">
                <p>制造云</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  v-model="signInfo.appId"
                  value="make-app"
                  class="weui-check"
                  id="x12"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area opr-block">
        <a
          class="weui-btn weui-btn__auto weui-btn_primary"
          :class="{ 'weui-btn_disabled': !isValidForm }"
          @click="register"
          >注册</a
        >
      </div>
      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__links">
            <router-link :to="loginUrl" class="weui-footer__link"
              >已有账号？立即登录</router-link
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "@/util/validator.js";
import wait from "@/mixins/wait.js";
import captcha from "@/mixins/captcha.js";
import Auth from "@/util/auth.js";
import Session from "@/util/session";
import QccSearchBox from "@/components/field/QccSearchBox";

export default {
  mixins: [wait, captcha],
  components: {
    QccSearchBox
  },
  data() {
    return {
      area: true, // true: 中国大陆;
      signInfo: {
        companyName: null,
        businessCode: null,
        userName: null,
        mobile: null,
        countryCode: '86',
        validCode: null,
        appId: "trade-app",
        inviteCode: null,
      },
      // 来自微信
      unionid: null,
      // 顾问信息，来自顾问邀请链接
      adviser: {
        name: ''
      },
      // 合作伙伴信息，来自合作伙伴企业名片
      partner: {
        name: ''
      },
      // 合作伙伴分享二维码的个人
      partnerUser: null,
      hasAuthInfo: false,
      validCodeSend: false,
      loading: true
    };
  },
  computed: {
    isMobileValid() {
      return Validator.isMobile(this.signInfo.mobile);
    },
    isLocked() {
      const me = this;
      return !me.isMobileValid || me.isWaiting;
    },
    isValidForm() {
      const me = this,
        signInfo = me.signInfo;
      if(me.area) {
        return (
          me.isMobileValid &&
          signInfo.companyName &&
          signInfo.businessCode &&
          signInfo.userName &&
          signInfo.validCode
        );
      } else {
        return (
          me.isMobileValid &&
          signInfo.companyName &&
          signInfo.userName &&
          signInfo.validCode
        )
      }
    },
    loginUrl() {
      var fullPath = this.$route.fullPath,
        index = fullPath.indexOf("?"),
        url = "/login";
      if (index > 0) {
        url += fullPath.substr(index);
      }
      return url;
    },
    isMobileChecked() {
      return this.isMobileValid && this.validCodeSend;
    },
    /**
     * 来自合作伙伴渠道
     */
    fromPartnerChannel() {
      return this.partner && this.partner.name;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let signInfo = to.params.signInfo,
        inviteCode = to.params.inviteCode,
        partnerUU = to.params.partner;
      if (signInfo) {
        vm.signInfo = Object.assign(signInfo, { appId: "trade-app", inviteCode: null });
      }
      if (inviteCode) {
        vm.getAdviserInfo(inviteCode);
      }
      if (partnerUU) {
        vm.getPartnerInfo(partnerUU);
        vm.partnerUser = to.params.partnerUser;
      }
      if (!inviteCode && !partnerUU && !to.query.inviteCode && !to.query.partner) {
        vm.loading = false;
      }
    });
  },
  mounted() {
    // 来自微信端，带有微信身份
    this.unionid = this.$route.query.unionid;
    // 来自合伙人邀请
    const inviteCode = this.$route.query.inviteCode;
    if (inviteCode) {
      this.getAdviserInfo(inviteCode);
    }
    // 来自合伙人邀请
    const partnerUU = this.$route.query.partner;
    if (partnerUU) {
      this.partnerUser = this.$route.query.partnerUser;
      this.getPartnerInfo(partnerUU);
    }
    if (!inviteCode && !partnerUU) {
      this.loading = false;
    }
  },
  methods: {
    selectAreaCode() {
      this.$weui.areaCodePicker((result) => {
        let label = result[0].label
        this.signInfo.countryCode = label.substring(label.indexOf('+') + 1)
      })
    },
    /**
     * 获取验证码
     */
    getValidCode() {
      const me = this;
      if (me.isLocked) {
        return;
      }
      me.$captcha.show();
      me.$bus.$on('getTicket', res => {
        if (res.ret === 0) {
          me.addWaitTask();
          me.$loading({
            url: "/api/account/company/register/vcode",
            method: "POST",
            params: {
              mobile: me.signInfo.mobile,
              countryCode: me.signInfo.countryCode,
              ticket: res.ticket,
              appId: res.appid,
              randstr: res.randstr
            },
          }).then(function (res) {
            if (res.success) {
              me.$weui.toast("发送成功", 2000);
              me.validCodeSend = true;
            } else {
              me.$weui.topTips("发送失败", 3000);
              me.clearWaitTask();
            }
          });
        } else {
          me.$weui.topTips('未通过验证');
        }
        me.$bus.$off('getTicket')
      })
    },
    /**
     * 注册
     */
    register() {
      const me = this;
      if (!me.isValidForm) {
        return;
      }
      var data = Object.assign({}, me.signInfo);
      if (me.fromPartnerChannel) {
        // 合作伙伴同时成为顾问
        data.inviteCode = me.partner.enuu + '-' + (me.partnerUser || 0);
      }
      me.area ? data.areaCategory = 10 : data.areaCategory = 20
      me.$loading({
        url: "/api/account/company/register/v2",
        method: "POST",
        jsonData: data,
      }).then(function (res) {
        if (res.success) {
          let authData = res.data;
          Auth.set(authData);
          if (me.unionid) {
            // 绑定微信账号
            me.bindWeixin(me.unionid).then(function () {
              me.$router.push("/" + authData.appId.replace("-app", ""));
            });
          } else if (me.fromPartnerChannel) {
            me.$router.push({
              name: "ApplyPartner",
              params: { partner: me.partner, authData, partnerUser: me.partnerUser }
            });
          } else {
            me.$router.push("/" + authData.appId.replace("-app", ""));
          }
        } else {
          me.$weui.topTips("注册失败：" + res.message, 3000);
        }
      });
    },
    /**
     * 绑定微信账号
     */
    bindWeixin(unionid) {
      return this.$loading({
        url: "/api/weixin/bind",
        method: "POST",
        params: {
          unionid,
        },
      });
    },
    /**
     * 顾问信息
     */
    getAdviserInfo(inviteCode) {
      const me = this;
      me.$ajax({
        url: "/api/account/partner/read",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data && data.name) {
            me.signInfo.inviteCode = inviteCode;
            me.adviser = data;
            // 来自于顾问直接邀请，主动鉴别当前终端身份，自动登录
            if (me.$route.query.inviteCode) {
              me.getAuthInfo();
            } else {
              me.loading = false;
            }
          } else {
            me.loading = false;
          }
        } else {
          me.loading = false;
        }
      });
    },
    /**
     * 主动获取cookie身份信息，用于顾问邀请时主动行为
     */
    getAuthInfo() {
      var me = this,
        token = Session.getToken(),
        headers = token ? {
          Authorization: token
        } : {};
      me.$ajax({
        url: "/api/auth/info",
        headers,
        withCredentials: true,
      }).then(function (res) {
        if (res.success) {
          me.hasAuthInfo = true;
          var authData = res.data;
          Auth.set(authData);
          if (authData.unauthorized) {
            // 出现该情况是从sso登录的企业，还未开通saas应用，需要提醒用户开通
            me.redirectRegister(authData.account, authData.unauthorized, authData.account.companies);
          } else if (!authData.companyId) {
            // 出现该情况是从sso以个人身份登录，需要提醒用户切换或注册企业
            me.applyAppFromSso(authData.account);
          } else {
            if (me.signInfo.inviteCode) {
              // 检查绑定顾问状态
              me.checkAdviserStatus(me.signInfo.inviteCode, authData);
            } else if (me.partner && me.partner.enuu) {
              // 检查绑定合作伙伴状态
              me.checkPartnerStatus(me.partner.enuu, me.partnerUser, authData);
            } else {
              me.loading = false;
            }
          }
        } else {
          me.loading = false;
        }
      });
    },
    /**
     * 跳转开通企业应用
     */
    redirectRegister(account, company, companies) {
      const me = this;
      me.$router.push({
        name: "AutoRegister",
        params: {
          signInfo: {
            mobile: account.mobile,
            userName: account.realname,
            companyName: company.name
          },
          inviteCode: me.signInfo.inviteCode,
          companies,
          partner: me.partner ? me.partner.enuu : null,
          partnerUser: me.partnerUser
        },
      });
    },
    /**
     * 选择需要开通saas的企业(sso中绑定的企业)
     */
    applyAppFromSso(account) {
      const me = this;
      me.getSsoCompanies(account.mobile).then(function (companies) {
        if (companies && companies.length) {
          if (companies.length == 1) {
            me.redirectRegister(account, companies[0], companies);
          } else {
            let items = companies.map((c) => {
              return {
                label: c.name,
                value: c,
              };
            });
            me.$weui.picker(items, {
              title: "选择公司，开通云系统",
              onConfirm: function (result) {
                me.redirectRegister(account, result[0].value, companies);
              },
            });
          }
        }
      });
    },
    /**
     * 查找sso中绑定的企业
     */
    getSsoCompanies(mobile) {
      const me = this;
      return me
        .$ajax({
          url: "/api/account/account/sso_companies",
          params: {
            mobile,
          },
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
    },
    /**
     * 检查绑定顾问的状态
     */
    checkAdviserStatus(inviteCode, authData) {
      const me = this;
      me.$ajax({
        url: "/api/account/partner/customer/status",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data;
          if (data.hasPartner) {
            let adviser = data.customer.partner;
            me.$weui.alert(
              `您的企业(${authData.account.defaultCompany.name})已经绑定了顾问 ${adviser.name}`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else if (data.inviter) {
            me.$weui.confirm(
              `${data.inviter.name} 将成为您企业(${authData.account.defaultCompany.name})的专属顾问`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "不同意",
                    type: "default",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                  {
                    label: "同意",
                    type: "primary",
                    onClick: function () {
                      me.bindAdviser(inviteCode, authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function(){
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    redirectApp(authData) {
      this.$router.push("/" + authData.appId.replace("-app", ""));
    },
    /**
     * 绑定顾问
     */
    bindAdviser(inviteCode, authData) {
      const me = this;
      me.$loading({
        url: "/api/account/partner/customer/open",
        method: 'post',
        params: {
          inviteCode
        }
      }).then(function(res){
        if (res.success) {
          let data = res.data;
          if (!data.hasPartner) {
            me.$weui.alert(
              `绑定顾问失败`,
              {
                title: "出错了",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.$weui.alert(
              `${data.inviter.name} 是您的专属顾问了`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function(){
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    /**
     * 合作伙伴信息
     */
    getPartnerInfo(uu) {
      const me = this;
      me.$ajax({
        url: "/api/account/company/sso_info",
        params: {
          uu
        },
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data && data.name) {
            me.partner = data;
            // 来自于合作伙伴直接邀请，主动鉴别当前终端身份，自动登录
            if (me.$route.query.partner) {
              me.getAuthInfo();
            } else {
              me.loading = false;
            }
          } else {
            me.loading = false;
          }
        } else {
          me.loading = false;
        }
      });
    },
    /**
     * 检查绑定合作伙伴的状态
     */
    checkPartnerStatus(enuu, userUU, authData) {
      const me = this;
      if (authData.account.defaultCompany.uu == enuu) {
        // 扫自己公司二维码的情况
        me.redirectApp(authData);
        return;
      }
      me.$ajax({
        url: "/api/account/company_partner/status",
        params: {
          enuu,
          userUU
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data, partner = me.partner;
          if (data.hasPartner || data.hasApply) {
            let message = data.hasPartner ? `已经绑定了合作伙伴${partner.name}`
              : `正在申请与${partner.name}合作`;
            me.$weui.alert(
              `您的企业(${authData.account.defaultCompany.name})${message}`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.$router.push({
              name: "ApplyPartner",
              params: { partner, authData, partnerUser: me.partnerUser }
            });
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function(){
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    /**
     * 企业名模糊查询选择
     */
    onCompanySelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.signInfo.businessCode = code;
    }
  },
  watch: {
    area(value) {
      if(value) this.signInfo.countryCode = '86'
    }
  }
};
</script>

<style scoped>
.opr-block {
  padding: 0 32px;
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.selector {
  margin: 0px 30px 20px 30px;
  display: flex;
  justify-content:space-between;
}

.selector span {
  width: 40%;
  border: 1px solid #ccc;
  padding: 8px 5px 7px 5px;
  border-radius: 5px;
  text-align: center;
}

.span-selected {
  font-weight: bold;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

